import React from 'react';
import Page from './Page';

const AboutPage = () => (
  <Page eyebrow="WHO WE ARE" title="About iCraftz">
    <p>
      iCraftz is an AI-powered self-improvement platform founded by{' '}
      <strong>Ashesh Thanawala</strong>. Inspired by Dr. Manjunath's philosophy
      that <em>reading without application is just entertainment</em>, iCraftz
      transforms non-fiction book wisdom into structured, actionable insights —
      delivered in 10 Indian and global languages.
    </p>
    <p>
      We believe great ideas should not be locked behind language. Our engine
      reads, distils and rewrites the world's best non-fiction into formats
      designed for memory, application and habit — across 10 languages
      including English, Hindi, Telugu, Tamil, Kannada, Marathi, Bengali,
      Gujarati, Malayalam and Punjabi.
    </p>
    <p className="legal-pull">Less Noise. More Thought.</p>
  </Page>
);

export default AboutPage;
